import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Christo from '../../assets/images/Team/Christo_Viljoen.jpeg'
import Gerhard from '../../assets/images/Team/Gerhard_Labuscagne.jpeg'
// import Anifa from '../../assets/images/Team/Anifa_Moosa.jpeg'
import Ashley from '../../assets/images/Team/Ashley_Swart.jpeg'
import Dane from '../../assets/images/Team/Dane_van_Rensburg.jpeg'
import Mariska from '../../assets/images/Team/Mariska_Reyneke.jpeg'
import Matumelo from '../../assets/images/Team/Matumelo_Matsoana.jpeg'
import Paula from '../../assets/images/Team/Paula-Mari_Ferreira.jpeg'

import Dian from '../../assets/images/Team/Dian Greef.jpeg'
import Istelle from '../../assets/images/Team/Istelle Brand.jpeg'
import Izelle from '../../assets/images/Team/Izelle van Rensburg.jpeg'
import Marthina from '../../assets/images/Team/Marthina Ras.jpeg'
import Matthew from '../../assets/images/Team/Matthew Mashava.jpeg'
import Riano from '../../assets/images/Team/Raino Human.jpeg'
// import StefanLeovac from '../../assets/images/Team/Stefan_Leovac.jpeg'
// import StefanTrouw from '../../assets/images/Team/Stefan_Trouw.jpeg'
// import Sunette from '../../assets/images/Team/Sunette_Du_Plessis.jpeg'
// import Yonela from '../../assets/images/Team/Yonela_Vena.jpeg'
import Zanele from '../../assets/images/Team/Zanele_Mahlangu.jpeg'
// import Zelmarie from '../../assets/images/Team/Zelmarie_Putzier-2.jpeg'
import { TeamMember } from '..';

export const Team: React.FC = React.memo(() => (
    <div className='about__team'>
        <h1 className='about__team__heading'>Team</h1>
        <h2 className='about__team__title'>Founders</h2>
        <div className='about__team__flex'>
            <TeamMember src={Gerhard} alt='Gerhard Labuschagne' flex />
            <TeamMember src={Christo} alt='Christo Viljoen' />
        </div>
        <h2 className='about__team__title'>Employees</h2>
        <div className='about__team__grid'>
        <TeamMember src={Ashley} alt='Ashley Swart' />
            <TeamMember src={Dane} alt='Dané Van Rensburg' />
            <TeamMember src={Dian} alt='Dian Greeff' />
            <TeamMember src={Istelle} alt='Istelle Brand' />
            <TeamMember src={Izelle} alt='Izelle van Rensburg' />
            {/* <TeamMember src={Anifa} alt='Anifa Moosa' /> */}
            <TeamMember src={Mariska} alt='Mariska Reyneke' />
            <TeamMember src={Marthina} alt='Marthina Ras' />
            <TeamMember src={Matthew} alt='Matthew Mashava' />
            <TeamMember src={Matumelo} alt='Matumelo Matsoane' />
            <TeamMember src={Paula} alt='Paula Mari Ferreira' />
            <TeamMember src={Riano} alt='Raino Human' />
            <TeamMember src={Zanele} alt='Zanele Mahlangu' />

        </div>
        <Link to='/contact' style={{ margin: 'auto' }}>
            <Button variant='contained' color='primary'>
                Book Appointment
            </Button>
        </Link>
    </div>
));
